import { Container, Typography, useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import SearchEngine from '../../../components/SearchEngine';
import Image from 'next/image';

const useStyles = makeStyles()((theme) => ({
  titleContainer: {
    color: 'white',
    textAlign: 'center',
    zIndex: 1,
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.9rem',
    minHeight: '28rem',
    padding: '5.25rem 1.5rem 2.25rem',
    [theme.breakpoints.up('md')]: {
      minHeight: '31rem',
      maxHeight: '33rem',
      padding: '5.75rem 2rem 2rem',
    },
    [theme.breakpoints.down('md')]: {
      minHeight: '24rem',
      padding: '4.75rem 1rem 1.5rem',
    },
  },
  landingImage: {
    zIndex: 0,
  },
  title: {
    position: 'relative',
    zIndex: 1,
    width: '100%',
  },
  baseLine: {
    // Double ampersand increases selector specificity against MUI Typography defaults.
    '&&': {
      fontSize: '1.05rem',
      lineHeight: 1.4,
      position: 'relative',
      fontWeight: 600,
      zIndex: 1,
      [theme.breakpoints.up('xs')]: {
        textAlign: 'center',
      },
      [theme.breakpoints.down('sm')]: {
        textAlign: 'left',
        fontSize: '0.95rem',
        padding: '0.8rem 1rem',
      },
      margin: 'auto',
      width: 'fit-content',
      maxWidth: '760px',
      background: 'rgba(255, 255, 255, 0.8)',
      padding: '0.9rem 1.25rem',
      borderRadius: '22px',
      color: 'black',
    },
  },
  h1: {
    textTransform: 'uppercase',
    [theme.breakpoints.up('md')]: {
      fontSize: '1.9rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.55rem',
    },
    lineHeight: 1.2,
    background: 'rgba(255, 255, 255, 0.8)',
    width: 'fit-content',
    textAlign: 'center',
    margin: 'auto',
    padding: '0.9rem 1.25rem',
    borderRadius: '22px',
    color: 'black',
  },
}));

interface PresentationSectionProps {
  id?: string;
}

const PresentationSection = ({ id }: PresentationSectionProps) => {
  const { classes: styles } = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Container maxWidth="xl" className={styles.titleContainer} id={id}>
      <Image
        className={styles.landingImage}
        src="/Accueil1.jpg"
        alt="Affiche OUAAA!"
        fill
        priority
        sizes="100vw"
        style={{ objectFit: 'cover', objectPosition: 'center' }}
      />
      <div className={styles.title}>
        <h1 className={styles.h1}>
          agir pour la transition écologique <br /> et sociale en aunis
        </h1>
      </div>
      <Typography className={styles.baseLine}>
        Nous sommes là pour te faire connaître celles et ceux qui œuvrent{' '}
        {!mobile && <br />}
        pour la transition écologique, sociale et démocratique, te donner le calendrier de leurs
        actions et te permettre de les rejoindre.
      </Typography>
      <SearchEngine />
    </Container>
  );
};

export default PresentationSection;
